<template>
  <div class="navbar">
    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar"/>
    <breadcrumb class="breadcrumb-container"/>
    <div class="right-menu">


      <!-- <AiButton /> -->

      <div class="right-menu-item">
        <screenfull id="screenfull" class="screenfull" ref="screenfull"></screenfull>
      </div>
      <div class="right-menu-item" v-if="manageEnterpriseList.length">
        <el-select style="width: 250px;" filterable v-model="coId" placeholder="请选择企业" >
          <el-option v-for="co in manageEnterpriseList" :selected="sourceId==co.id" @click.native="openCo(co)" :key="co.id" :label="co.name" :value="co.id"></el-option>
        </el-select>
      </div>
      <div class="right-menu-item" @click="btnEditPwd">修改密码</div>
      <div class="right-menu-item userHeader">
        <el-avatar :size="40" :src="avatar"></el-avatar>
        <span class="userName">你好，{{ name }}</span>
      </div>
      <div class="right-menu-item" @click="logout">安全退出</div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Screenfull from "@/components/Screenfull";
import { changeCo } from "@/api/login";

import AiButton from "@/components/AiButton/aiButton.vue";


export default {
  components: {
    Screenfull,
    Breadcrumb,
    Hamburger,

    AiButton
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'name',
      'manageEnterpriseList',
      'sourceId'
    ])
  },
  data(){
    return {
      coId:"",
      recordCoId: ""
    }
  },

  mounted(){
    console.log(this.manageEnterpriseList,this.sourceId)
    if(this.manageEnterpriseList.findIndex(item => item.id == this.sourceId) != -1){
      this.coId = this.sourceId
      this.recordCoId = this.sourceId
    }
  },
  methods: {
    /**
     * 打开企业
     */
    openCo(co){
      this.$nextTick(() => {
        this.coId = this.recordCoId
      })


      changeCo({enterpriseId:co.id }).then(res => {

        if(res.data && res.data.token){
          window.open(`/?#/welcome?enterpriseId=${co.id}&inname=${co.name}&token=${res.data.token}`)

            // this.$store.commit('user/SET_TOKEN',res.data.token)

            //获取文件前缀
            // getPrefix().then((res) => {
            //   if (res) {
            //     sessionStorage.setItem("prefixImgUrl", res.data.baseUploadUrl);
            //     // sessionStorage.setItem('prefixImgUrl', "https://studys.cloudjoytech.com.cn") //临时写死
            //   }
            // });

        }
        // window.open(`/?#/welcome?enterpriseId=${co.id}&inname=${co.name}&token=${res.data.token}`)
      })
      // window.open(`/?#/login?enterpriseId=${co.id}&inname=${co.name}`)
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    logout() {
      this.$confirm('是否确定退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('user/logout').then(() => {
          this.$message({
            type: 'success',
            message: '退出成功'
          });
          this.$router.push(`/login?redirect=${this.$route.fullPath}`)
          sessionStorage.clear();
          this.loading = false
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    //修改密码
    btnEditPwd() {
      this.$router.push({path: "/personal/editPwd"})
    }
  }
}
</script>

<style lang="scss" scoped>
.screenfull {
  text-align: center;
  cursor: pointer;
}

.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .userHeader span {
      margin-left: 10px;
      vertical-align: middle
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 20px;
      height: 100%;
      font-size: 14px;
      color: #5a5e66;
      vertical-align: text-bottom;
      cursor: pointer;
      min-width: 100px;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }
  }
}
</style>
